import { render, staticRenderFns } from "./StoreStandardStockRegist.vue?vue&type=template&id=5a5c221d&"
import script from "./StoreStandardStockRegist.vue?vue&type=script&lang=js&"
export * from "./StoreStandardStockRegist.vue?vue&type=script&lang=js&"
import style0 from "./StoreStandardStockRegist.vue?vue&type=style&index=0&id=5a5c221d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports